<script lang="ts">
	import type { VisualBlock } from '$models/Block/VisualBlock';
	import { getWordPressImageSrcSet } from '$lib/images';

	let { block }: { block: VisualBlock } = $props();
</script>

{#if block.image}
	<div
		class="visual-container"
		class:visual-container--full-width-mobile={block.fullWidthMobile}
	>
		<figure class="visual">
			<img
				src={block.image.url}
				srcset={getWordPressImageSrcSet(block.image)}
				sizes="100vw"
				alt={block.image.alt}
				width={block.image.width}
				height={block.image.height}
				loading="lazy"
				decoding="async"
			/>
		</figure>
	</div>
{/if}

<style lang="postcss">
	.visual-container {
		margin-inline: calc(-1 * var(--spacing-4));
		padding: var(--spacing-4);

		@media (--md) {
			margin-inline: 0;
			padding: 0;
			background-color: transparent !important;
		}
	}

	.visual-container--full-width-mobile {
		padding: 0;

		.visual {
			border-radius: 0;

			@media (--md) {
				border-radius: 12px;
			}
		}
	}

	.visual {
		overflow: hidden;
		border-radius: 12px;
	}

	.visual img {
		display: block;
		width: 100%;
		height: auto;
	}
</style>
